import { cn } from '@/common/lib/utils'
import { Skeleton } from '@/common/ui/skeleton'

interface MessageSkeletonProps {
	isOutgoing: boolean
}

export function MessageSkeleton({ isOutgoing }: MessageSkeletonProps) {
	return (
		<div
			className={cn('flex gap-2', isOutgoing ? 'flex-row-reverse' : 'flex-row')}
		>
			{!isOutgoing && <Skeleton className="h-8 w-8 rounded-full" />}
			<Skeleton
				className={cn(
					'h-16 rounded-2xl',
					isOutgoing ? 'w-48 rounded-br-sm' : 'w-64 rounded-bl-sm',
				)}
			/>
		</div>
	)
}
